import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { LegacyButton } from '@/components/LegacyButton';
import { NextImageWithLoader } from '@/components/NextImageWithLoader';

import { ReactComponent as SizingRulerLarge } from '@/assets/sizing-ruler-large.svg';
import { ReactComponent as SizingRulerSmall } from '@/assets/sizing-ruler-small.svg';

export const BodyWrapper = styled(Box)`
  text-align: center;

  ${({ theme }) => css`
    padding-top: ${theme.spacing(3)};
    padding-inline: ${theme.spacing(2)};

    ${theme.media.sm.up} {
      padding-inline: ${theme.spacing(4)};
    }
  `}
`;

export const Image = styled(NextImageWithLoader)`
  position: relative;
  width: 100%;
  height: 160px;
  background-color: ${({ theme }) => theme.colors.mediumGrey};
  .next-image {
    object-fit: cover;
    inset: 0;
  }
`;

export const SizingRulerMobileSvg = styled(SizingRulerSmall)`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing(2)};

  ${({ theme }) => css`
    ${theme.media.sm.up} {
      display: none;
    }
  `}
`;

export const SizingRulerDesktopSvg = styled(SizingRulerLarge)`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing(2)};

  ${({ theme }) => css`
    ${theme.media.sm.down} {
      display: none;
    }
  `}
`;

export const PrintButton = styled(LegacyButton)`
  ${({ theme }) => css`
    ${theme.media.sm.down} {
      width: 100%;
    }
  `}
`;
